module.exports = __webpack_public_path__ + "fonts/SFUIText-Heavy.575ee70b.woff";